/*********************************************************
 * Third Controls
*********************************************************/
import React, { useRef, useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IconButton, Icon } from '@mui/material';
import { useIntl } from "react-intl";

/*********************************************************
 * Controls
*********************************************************/
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Input, Form, Button } from 'Components';
import { FileUploadComponent } from 'Components/FileUpload';
import { useFileUpload } from 'Core/hooks';
import { csvJSON, downloadFile } from 'Core/data/Helpers'; 
import Table, { Column } from 'Components/Table';
import { getGeocoder } from 'Components/Map/providers/googleGeocoder'
import { Tooltip } from 'Components';
import { NotificationManager } from "Components/Notifications";

/*********************************************************
 * Actions
*********************************************************/
import {
  openModalRealtimeMapsRoutesCreateEditRoute,
  realtimeMapsRoutesCreateUpdateRoute,
  openModalCreateEditRouteModalMain,
  onUpdateRoute
} from 'Redux/actions';

/*********************************************************
 * Add resets
*********************************************************/
import { reset as resetUploadRoute } from "./redux/slice"
import { Countertops } from '@mui/icons-material';


const defaulRadius = 32.18688; // 0.02 miles;
const defaultColorRoutes = '8677D9';

/*********************************************************
 * Class to upload the file of routes
*********************************************************/
const UploadRoute = (props) => {

  const { isRealtimeMaps } = props

  const { messages } = useIntl();

  const formCreateRoute = useRef();
  const tableRef = useRef();
  const filesUpload = useFileUpload([]);
  const [title, setTitle] = useState('');
  const [attachments, setAttachments] = useState([]);
  const [dataAddres, setDataAddress] = useState([])


  const dispatch = useDispatch()

  /*********************************************************
  * Selectors
  ********************************************************/

  const open = useSelector(state => state.realtimeMapsRoutesModalUploadRoute.open); 
  const loadingRoute = useSelector(state => state.realtimeMapsRoutesModalUploadRoute.loading); 
  const route = useSelector(state => state.realtimeMapsRoutesModalUploadRoute.route); 
  const error = useSelector(state => state.realtimeMapsRoutesModalUploadRoute.error); 

  useEffect(() => {
    return () => {
      dispatch(resetUploadRoute())
    }
  }, []);

  /*********************************************************
  * Coming the data after create route
  ********************************************************/
  useEffect(()=>{
    if(route && error != true){
      
      //to close modal create edit route
      dispatch(resetUploadRoute())
      setDataAddress([])

      //to open new route with the data.
      //dispatch(openCreateEditRoute({ open: true, id: route?.id }));
      if(isRealtimeMaps){
        dispatch(openModalRealtimeMapsRoutesCreateEditRoute({ open: true, routeId: route?.id, isTemplate: true }));
      }else{
        dispatch(openModalCreateEditRouteModalMain({open: true, id: route?.id, isTemplate: true}));
      }
      
    }
  },[route])


  useEffect(() => {
    if (error) {
        NotificationManager.error(
          messages[error],
          messages['error'],
          3000,
          null,
          null,
          'warning',
        );
    } 
  }, [error]);

  /*********************************************************
  * Evaluate end all petitions
  ********************************************************/
  useEffect(()=> {
    if(dataAddres && dataAddres.length > 0){
      const filterData = dataAddres.filter((item) => item.process == true);
      if(filterData && filterData.length == dataAddres.length){
      }
    }
  },[dataAddres])

  /*********************************************************
  * Perform the close modal
  ********************************************************/
  const handleClose = useCallback(() => {
    //close the modal
    dispatch(resetUploadRoute())

    setDataAddress([])
  });

  /*********************************************************
  * Save elements on form
  ********************************************************/
  const onSubmit = useCallback(() => {

    const routePoints = [];
    let sequence = 0; 

    const nameCounts = {}; // Objeto para contar ocurrencias de cada nombre

    dataAddres.forEach((item, index)=> {

      const baseName = item?.Address || 'point'; // Use the attribute instead of 'Address'
      nameCounts[baseName] = (nameCounts[baseName] || 0) + 1; // Increment the counter
      const currentCount = nameCounts[baseName];
      
      // Generate a unique name if there are duplicates
      const uniqueName = currentCount === 1 
        ? baseName 
        : `${baseName} (${currentCount - 1})`;

      routePoints.push({
        id: (index + 1) * -1000,
        name: uniqueName, //create a unike name for route points before the upload route
        address : item.Address,
        city: item.City,
        state: item.State,
        latitude: parseFloat(item.Latitude),
        longitude: parseFloat(item.Longitude),
        sequence: sequence,
        landmarkId: null,
        radius: defaulRadius, //default radius
        note: item.Notes,
        typePoint: 'Stop',
        counterStop: sequence,
        value: sequence
      })
      sequence = sequence + 1;
    })
    
    const newRoute = {
      title: title,
      color: defaultColorRoutes, //default color for routes
      optimized: false,
      avoidToll: false,
      isTemplate: true,
      distanceMeters: 0,
      points: routePoints
    }


    if(isRealtimeMaps){
      dispatch(openModalRealtimeMapsRoutesCreateEditRoute({ open: true, isTemplate: true }));
    }else{
      dispatch(openModalCreateEditRouteModalMain({open: true, isTemplate: true}));
    }

    dispatch(onUpdateRoute({ route: newRoute, changesToSave: true }))
    handleClose()
    
  });

  /*********************************************************
  * return address data from geocoder query object
  ********************************************************/
  const returnDataAddress = (data, id) => {
    if(data && data.length > 0){
      const element = {
        id: id,
        Latitude: data[0].lat.toFixed(6),
        Longitude: data[0].lng.toFixed(6),
        Address: data[0]?.address1, //fulladdress
        City: data[0]?.city,
        State: data[0]?.state,
        Zip: data[0]?.postalcode,
        Notes: data[0]?.note
      }
      return element;
    }
    return null
  }

  /*********************************************************
  * Create the petitions sincronized to address.
  ********************************************************/
  const createPetitions = async (arrayElements = [], index = 0) => {
    let result = [...dataAddres];
    let item = arrayElements[index];
    await new Promise(async (resolve, reject) => {
      let item_1 = { ...item, newId: index };
      if (!item?.Latitude || !item?.Longitude) {
        findLatLngByAddress(item_1, index, resolve, reject)
      } else if (!item?.Address || item?.Address ===  "\"\"") {
        findAddressByLatLng(item_1, index, resolve, reject)
      } else {
        const newArrayElements = arrayElements.map(element => {
          if(element.id == item.id){
            element = {...element, process: true}
          }
          return element;
        });
        setDataAddress([...newArrayElements]);
      }
    })
    .then((data)=> { //When get directions from route is success
      if(data != null){
        const { index: index_1, object } = data;
        const newArrayElements = arrayElements.map(element => {
          if(element.id == index_1){
            element = {...element, ...object, process: true}
          }
          return element;
        });
        setDataAddress([...newArrayElements]);
        if(index_1 < arrayElements.length){
          setTimeout(function () {
            createPetitions(newArrayElements, index_1 + 1);
          }, 500);
        }
      }
    })
    .catch((data)=>{ //When get directions from route generate error.
      if(data != null){
        const { index: index_1, error } = data;
        const newArrayElements = arrayElements.map(element => {
          if(element.id == index_1){
            element = {...element, process: true, error: true}
          }
          return element;
        });
        setDataAddress([...newArrayElements]);
        if(index_1 < arrayElements.length){
          setTimeout(function () {
            createPetitions(newArrayElements, index_1 + 1);
          }, 500);
        }
      }
    })

    return result;
  }

  /*********************************************************
  * Find LatLng by address 
  ********************************************************/
  const findLatLngByAddress = useCallback((item, id, resolve, reject) => {
    getGeocoder({
      from: 'address', //latlng, address, placeId
      address: item?.Address,
      callback: (address) => { 
        if(address && address.result == true){
          const { data } = address
          const element = returnDataAddress(data, id);
          if(element){
            resolve({ index: id, object: element });
            return
          }
        }
        reject({ index: id, error: Error('No find Address') })
      }
    })
  })

  /*********************************************************
  * Find address by lat,lng
  ********************************************************/
  const findAddressByLatLng = useCallback((item, id, resolve, reject) => {
    getGeocoder({
      from: 'latlng', //latlng, address, placeId
      lat: item.Latitude,
      lng: item.Longitude,
      callback: (address) => { 
        if(address && address.result == true){
          const { data } = address
          const element = returnDataAddress(data, id);
          if(element){
            resolve({ index: id, object: element });
          }
        }
        reject({ index: id, error: Error('No find Address') })
      }
    })
  })

  /*********************************************************
  * Read the csv file
  ********************************************************/
  const readFileAsString = (files) => {

    if (files.length === 0) {
        return;
    }

    var reader = new FileReader();
    reader.onload = async (event) => {
      //Get data from file, convert plane to CSV
      const jsonData = csvJSON(event.target.result);
      if(!validateColumns(jsonData)){
        setDataAddress([]);
        return
      } 
      let countElements = -1;
      const jsonDataIndex = jsonData.map((item)=> {
        if(item && ((item?.Latitude && item?.Longitude) || item?.Address)){
          countElements = countElements + 1;
          return {...item, id: countElements, process: false, error: false};
        }
        return null
      })
      createPetitions(jsonDataIndex.filter(item => item != null));
    };

    reader.readAsText(files);
    const arrayTemp = []
    arrayTemp.push({...files, originalName: files.name });
    setAttachments(arrayTemp);
  }

  /*********************************************************
  * Validate rows and colums from file
  ********************************************************/
  const validateColumns = (jsonData) => {
    let validation = true

    //No more 25 rows
    if(jsonData.length >= 25){
      NotificationManager.error('Error', messages['routes_attachments_max'], 3000, null, null, 'error');
      return false;
    }

    jsonData.forEach((item)=> {
      if(!item.hasOwnProperty('Latitude')) validation = false;
      if(!item.hasOwnProperty('Longitude')) validation = false;
      if(!item.hasOwnProperty('Address')) validation = false;
      if(!item.hasOwnProperty('City')) validation = false;
      if(!item.hasOwnProperty('State')) validation = false;
      if(!item.hasOwnProperty('Zip')) validation = false;
      if(!item.hasOwnProperty('Notes')) validation = false;
    })
    if(!validation){
      NotificationManager.error('Error', messages['routes_attachments_error'], 3000, null, null, 'error');
    }

    return validation;
  }

  /*********************************************************
  * Download the template file to upload data.
  ********************************************************/
  const downloadCSVTemplate = () => {
    let csvContent = 'Latitude,Longitude,Address,City,State,Zip,Notes' + '\n';
    downloadFile(csvContent, 'route-template.csv', 'text/csv;encoding:utf-8')
  }


  return (
    <Modal
      title={messages['realtimeMapsRoutes_uploadRoutes_upload']}
      open={open || false}
      position="right"
      size="small"
      handleClose={handleClose}
      className="create-route-container"
      headerStyle={!isRealtimeMaps ? undefined : { top: 0 }}
    >
      <ModalBody>
        {
          <Form ref={formCreateRoute} onValidSubmit={onSubmit}>
            <div style={{ padding: isRealtimeMaps ? '0px 24px' : '48px 24px 24px 24px' }}>
              <div>
                <Input
                  id="title"
                  name="title"
                  type="text"                    
                  label={messages['realtimeMapsRoutes_uploadRoutes_name']}
                  placeholder={messages['realtimeMapsRoutes_uploadRoutes_name']}
                  value={title || ""}
                  onChange={(value) => {
                    setTitle(value)
                  }}
                  minLength={4}
                  maxLength={50}
                  required
                  requiredMessage={messages['required_field']}
                />
              </div>
              <div>
                <FileUploadComponent
                  multiple={false}
									{...filesUpload}
									label={messages['routes_file']}
									placeholder={ messages["updateService_attachmentsInputPlaceholder"] }
									types=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
									helpText={messages['realtimeMapsRoutes_uploadRoutes_attachmentsFilesAllowed']}
									maxSize={4}
									maxSizeMessage={`${messages['max']}: 4MB`}
                  required
                  requiredMessage={messages['required_field']}
                  noDownloadButton
                  value={attachments}
                  onReadFile={readFileAsString}
                  onChange={()=>{
                    setAttachments([]);
                    setDataAddress([]);
                  }}
								/>
              </div>
              <div>
                <Table
                  viewStyle={'small'}
                  data={dataAddres || []}						
                  rowsPerPage={10}
                  loading={false}
                  hideSelectableCheckbox={true}
                  name="upload-route-grid"
                  topSpaceSize={426}
                  setColumnVisibility={false}
                  setColumnResizing={false}
                  hideDownloadButton={true}
                  hidePdfOption={true}
                  ref={tableRef}
                  valuesPerPage={[10]}
                  hideAllInPagination
                  hideSearchForm
                  disableSort={false}
                >
                  <Column disableSort label={messages['realtimeMapsRoutes_uploadRoutes_latitude']} field="Latitude">
                    {(item) => {
                      let colorRow = item.process ? '#66bb6a' : 'black'
                      colorRow = item.error ? 'red' : colorRow
                      return <span style={{ color : colorRow }}>{item?.Latitude}</span>;
                    }}
                  </Column>
                  <Column disableSort label={messages['realtimeMapsRoutes_uploadRoutes_longitude']} field="Longitude">
                    {(item) => {
                      let colorRow = item.process ? '#66bb6a' : 'black'
                      colorRow = item.error ? 'red' : colorRow
                      return <span style={{ color : colorRow }}>{item?.Longitude}</span>;
                    }}
                  </Column>
                  <Column disableSort label={messages['realtimeMapsRoutes_uploadRoutes_address']} field="Address">
                    {(item) => {
                      let colorRow = item.process ? '#66bb6a' : 'black'
                      colorRow = item.error ? 'red' : colorRow
                      return <span style={{ color : colorRow }}>{item?.Address}</span>;
                    }}
                  </Column>
                  <Column disableSort label={messages['realtimeMapsRoutes_uploadRoutes_city']} field="City">
                    {(item) => {
                      let colorRow = item.process ? '#66bb6a' : 'black'
                      colorRow = item.error ? 'red' : colorRow
                      return <span style={{ color : colorRow }}>{item?.City}</span>;
                    }}
                  </Column>
                  <Column disableSort label={messages['realtimeMapsRoutes_uploadRoutes_state']} field="State">
                    {(item) => {
                      let colorRow = item.process ? '#66bb6a' : 'black'
                      colorRow = item.error ? 'red' : colorRow
                      return <span style={{ color : colorRow }}>{item?.State}</span>;
                    }}
                  </Column>
                  <Column disableSort label={messages['realtimeMapsRoutes_uploadRoutes_zip']} field="Zip">
                    {(item) => {
                      let colorRow = item.process ? '#66bb6a' : 'black'
                      colorRow = item.error ? 'red' : colorRow
                      return <span style={{ color : colorRow }}>{item?.Zip}</span>;
                    }}
                  </Column>
                  <Column disableSort label={messages['realtimeMapsRoutes_uploadRoutes_note']} field="Notes">
                    {(item) => {
                      let colorRow = item.process ? '#66bb6a' : 'black'
                      colorRow = item.error ? 'red' : colorRow
                      return <span style={{ color : colorRow }}>{item?.Notes}</span>;
                    }}
                  </Column>
                </Table>
              </div>              
            </div>
          </Form>
        }
      </ModalBody>

      <ModalFooter style={{ borderTop: '1px solid #e0e0e0', bottom: isRealtimeMaps ? 50 : undefined }}>
        <Button
          disabled={loadingRoute}
          onClick={handleClose}
          className="btn-cancel"
        >
          {messages['realtimeMapsRoutes_uploadRoutes_cancel']}
        </Button>
        <Button
          disabled={loadingRoute /* || loadingUploadFile */}
          className="btn-blue"
          onClick={(e) => {
            e.preventDefault();
            formCreateRoute.current.submit();
          }}
        >
          {messages['realtimeMapsRoutes_uploadRoutes_upload_route']}
        </Button>

        <Tooltip title={messages['realtimeMapsRoutes_uploadRoutes_template']} placement={'top-start'}>
          <IconButton
            aria-haspopup="true"
            onClick={()=>{ downloadCSVTemplate(); }}
            color="inherit"
            size="large">
            <Icon>{'download'}</Icon>
          </IconButton>
        </Tooltip>        
      </ModalFooter>
    </Modal>
  );

}

export default UploadRoute;